<template>
  <div id="app">
    <router-view />
  </div>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <HelloWorld msg="Welcome to Your Vue.js App" />
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
//import MailApproval from './components/MailApproval.vue';

import { createApp } from 'vue';
import { createRouter, createWebHistory  } from 'vue-router';

//import InfoPage from './components/SellApproval.vue';


const routes = [
  { path: '/', component: HelloWorld }
  //,
  //{ path: '/mailApproval', component: MailApproval }
];
const router = createRouter({
  history: createWebHistory(),
  routes

});

const app = createApp({});
app.use(router);
//app.use(rt);
app.mount('#app');


export default {
  name: 'App',
  components: {
   // HelloWorld
  }
}
</script>

<style>
/* 全局重置样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background-color: #f5f5f5;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}
</style>

